var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 628.69 330.88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C3_White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "translate(-1185.6 -1334.6)",
    d: "m1224.3 1435.4 109-62.92a2 2 0 0 1 2 0l100.17 57.84 32.66-24.64-114-65.8a39.69 39.69 0 0 0-39.61 0l-109 62.92a39.71 39.71 0 0 0-19.82 34.31v125.83a39.72 39.72 0 0 0 19.82 34.31l109 62.92a39.72 39.72 0 0 0 39.61 0l114-65.8-32.64-24.62-100.17 57.82a1.9 1.9 0 0 1-2 0l-109-62.92a1.93 1.93 0 0 1-1-1.71v-125.83a2 2 0 0 1 0.98-1.71z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "translate(-1185.6 -1334.6)",
    d: "m1794.5 1402.8-109-62.92a39.72 39.72 0 0 0-39.63 0l-114 65.8 32.66 24.64 100.17-57.84a2 2 0 0 1 2 0l109 62.92a2 2 0 0 1 1 1.71v40.12h-110.85v37.64h110.82v48.07a2 2 0 0 1-1 1.71l-109 62.92a1.93 1.93 0 0 1-2 0l-100.17-57.82-32.53 24.62 114 65.8a39.76 39.76 0 0 0 39.63 0l109-62.92a39.72 39.72 0 0 0 19.82-34.31v-125.83a39.71 39.71 0 0 0-19.92-34.31z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC3);
export default __webpack_public_path__ + "static/media/c3.a02f5751955d4cfb065966b208a53aec.svg";
export { ForwardRef as ReactComponent };